import { render, staticRenderFns } from "./DelHistoryFileTip.vue?vue&type=template&id=22bee936"
import script from "./DelHistoryFileTip.vue?vue&type=script&lang=js"
export * from "./DelHistoryFileTip.vue?vue&type=script&lang=js"
import style0 from "./DelHistoryFileTip.vue?vue&type=style&index=0&id=22bee936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports